import { Checkbox, Form, FormInstance } from 'antd';
import cx from 'classnames';
import { MutableRefObject, useEffect, useRef } from 'react';
import { MeetingType } from 'commons/types/meetingsTypes';
import CGU_VALUES from './CGUContentType';

interface CGUsProps {
  form: FormInstance;
  rdvType: MeetingType;
  hideCGUs: boolean;
}
export default function CGUs({ form, rdvType, hideCGUs }: CGUsProps) {
  const bottomEl = useRef<HTMLDivElement | null>(null);

  return (
    <div className='text-center text-sm'>
      {CGU_VALUES[rdvType].length > 0 && !hideCGUs && (
        <div>
          <p className='m-0'>
            Afin de confirmer votre rendez-vous veuillez lire et accepter les
            règles de conduite à respecter
          </p>
          <p className='text-xs mb-8'>(cliquez sur chacune des règles)</p>
        </div>
      )}
      {!hideCGUs &&
        CGU_VALUES[rdvType].map((cgu, index, values) => {
          const previousKey = index > 0 ? values[index - 1].key : '';
          return (
            <CGU
              key={cgu.key}
              bottomEl={bottomEl}
              form={form}
              cgu={cgu}
              previousKey={previousKey}
            />
          );
        })}
      <div ref={bottomEl} />
    </div>
  );
}

interface CGUProps {
  form: FormInstance;
  bottomEl: MutableRefObject<HTMLDivElement | null>;
  cgu: {
    key: string;
    title: string;
    content: string;
  };
  previousKey: string;
}

function CGU({ form, bottomEl, cgu, previousKey = '' }: CGUProps) {
  const watcher: boolean = Form.useWatch(cgu.key, form);
  const previousKeyWatcher: boolean = Form.useWatch(previousKey, form);

  useEffect(() => {
    if (bottomEl?.current) {
      bottomEl.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [bottomEl, watcher]);

  if (previousKey !== '' && !previousKeyWatcher) {
    return null;
  }

  return (
    <Form.Item
      name={cgu.key}
      valuePropName='checked'
      key={cgu.key}
      className={cx('text-left text-secondary rounded-2xl !m-2 !px-3 !py-2', {
        'bg-primary-light': !watcher,
        'bg-white': watcher,
      })}
    >
      <Checkbox>
        <div className='text-xs'>
          <h3 className='font-semibold text-sm'>{cgu.title}</h3>
          <p>{cgu.content}</p>
        </div>
      </Checkbox>
    </Form.Item>
  );
}
